// extracted by mini-css-extract-plugin
export default {"wrapper":"pay_wrapper__crDHa","container":"pay_container__-pddi","img":"pay_img__xFT+U","btnBox":"pay_btnBox__bTpFX","btn1":"pay_btn1__0WVx1","btn2":"pay_btn2__fqCgx"};